<template>
  <button
    :class="[
      $style.button,
      theme && $style[`theme--${theme}`],
      size && $style[`size--${size}`],
      disabled && $style.disabled
    ]"
    :type="type"
    :disabled="disabled"
    @click="handleEvent"
    :style="{ width }"
    ref="button"
  >
    <b-svg
      v-if="iconLeft"
      :class="$style.icon"
      v-bind="iconLeft"
    />

    <slot></slot>

    <b-svg
      v-if="iconRight"
      :class="$style.iconRight"
      v-bind="iconRight"
    />
  </button>
</template>

<script>
export default {

  emits: [
    'click',
  ],
  name: 'BttnLegacy',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    iconLeft: {
      type: Object,
      default: null,
    },
    iconRight: {
      type: Object,
      default: null,
    },
    width: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      eventInfo: null,
    }
  },
  methods: {
    handleEvent (e) {
      const { type } = e
      this.eventInfo = {
        type,
      }
      this.$refs.button.blur()
      this.$emit('click', e)
    },
  },
}
</script>

<style lang="scss" module>
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: $color-white;
  background: $color-primary;
  border: 1px solid transparent;
  border-radius: $border-radius-sm;
  padding: 1rem 36px;
  @include font-size(14px, 1);
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;

  @include media-breakpoint-down($breakpoint-mobile) {
    padding: 1rem 20px;
  }
}

.disabled {
  background-color: $color-gray-13;
  color: $color-white;
  cursor: not-allowed;
  pointer-events: none;
}

.theme {
  &--secondary {
    border: 1px solid $color-border-gray;
    background-color: $color-white;
    color: $color-primary;
    box-shadow: $box-shadow-button;

    &.disabled {
      background-color: $color-white;
      color: $color-gray-11;
    }
  }
  &--danger {
    @extend .theme--secondary;
    color: $color-status-red;
  }

  &--pure {
    border: none;
    background-color: transparent;
    color: $color-primary;

    &.disabled {
      background-color: $color-white;
      color: $color-gray-11;
    }
  }

  &--icon,
  &--iconSecondary {
    width: 48px;
    height: 48px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 28px 48px 0 rgba(62, 53, 71, .18);
    .icon {
      margin-right: 0;
      width: auto;
      height: auto;
      font-size: 32px;
    }
  }
  &--iconSecondary {
    border: $border-gray-02;
    border-color: #c7cbd4;
    background-color: $color-white;
    color: $color-primary;
    box-shadow: $box-shadow-button;
    &.disabled {
      background-color: $color-white;
      color: $color-gray-11;
      opacity: .25;
    }
  }
  &--rounded-icon {
    border: none;
    background-color: $color-white;
    color: $color-primary;
    box-shadow: none;
    font-weight: 400;
    line-height: 22px;
    text-transform: capitalize;
    padding: 0;
    .icon,
    .iconRight {
      margin: 10px;
      width: auto;
      height: auto;
      border-radius: 50%;
      color: #d4d4d4;
      box-shadow: $box-shadow-card;
      transition: $transition;
    }
    &:hover {
      .icon,
      .iconRight {
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .1);
      }
    }
  }
  &--input {
    background-color: $color-white;
    border: 1px solid $color-gray-14;
    color: $color-primary;
    padding: 15px 16px;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
  }
}

.size {
  &--big {
    padding: 1rem 22px;
  }
  &--medium {
    padding: 12px 22px;
  }
  &--extra-small {
    font-size: 12px;
    padding: 9px 16px;
    font-weight: 600;
  }
  &--small {
    padding: 12px;
  }
  &--xsmall {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 1;
    .iconRight,
    .iconLeft {
      width: auto;
      height: auto;
    }
    .iconRight {
      margin-left: 7px;
    }
    .iconLeft {
      margin-right: 7px;
    }
  }
  &--micro {
    padding: 6px 12px;
    font-size: 12px;
  }
  &--fluid {
    width: 100%;
  }
}

.icon {
  width: 1.5rem;
  height: 1.5rem;
  // margin-right: 4px;
  margin-right: 8px;
  display: inline-flex;
}

.iconRight {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-flex;
}
</style>
